import { useEffect } from 'react'

export function useMouseMove<T>(callback: (e: MouseEvent) => T, deps = []) {
  useEffect(() => {
    const onMouseMove = (e: MouseEvent) => {
      callback(e)
    }

    window.addEventListener('mousemove', onMouseMove, false)

    return () => {
      window.removeEventListener('mousemove', onMouseMove, false)
    }
  }, [callback, ...deps])
}
